/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./BackgroundImage.css'); }
exports.BackgroundImage = function (_a) {
    var src = _a.src;
    return (React.createElement("div", { className: "m-background-image", style: { backgroundImage: "url(" + src + ")" } }));
};
exports.BackgroundImage.propTypes = {
    src: PropTypes.string.isRequired
};